// Copyright ©️ 2026 eVolve MEP, LLC

import { today, type TimeFrameData, type TimeFrameParams } from '@evolvemep/api-ts';

import { isNil } from 'helpers/isNotNil';

/**
 * Converts a `TimeFrameData` into the proper url params for an HTTP request.
 *
 * NOTE: On the backend, this becomes an `ITimeFrameRequest`
 */
export const convertTimeFrameDataToRequestParams = (data: TimeFrameData): TimeFrameParams => {
  if (data.timeFrame === 'Specific Date') {
    if (isNil(data.date)) return {};
    return {
      timeFrame: 'Specific Date',
      specificDate: data.date,
    };
  }
  if (data.timeFrame === 'Date Range') {
    if (isNil(data.dateRange) || data.dateRange.some(isNil)) return {};
    return {
      timeFrame: 'Date Range',
      beginDate: data.dateRange[0],
      endDate: data.dateRange[1],
    };
  }
  return {
    timeFrame: data.timeFrame,
    currentDate: today(),
  };
};
